import Model from "./Model";

export default class ProfissionalDeApoio extends Model {
  constructor(ProfissionalDeApoio) {
    super();
    Object.assign(this, ProfissionalDeApoio);
  }
}
